import axios from "axios";

const init = () => {
    let instance = null;
    return () => {
        if (!instance) {
            instance = create();
            interceptorsReponse(instance);
            interceptorsRequest(instance);
        }
        return instance;
    };
};

const create = () => {
    return axios.create({
        timeout: 20000,
    });
};

const interceptorsRequest = (instance) => {
    return instance.interceptors.request.use(
        (config) => {
            if (config.method.toUpperCase() === "GET") {
                if (!config.params) {
                    config.params = {};
                }
                config.params.t = Date.now();
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};

const interceptorsReponse = (instance) => {
    return instance.interceptors.response.use(
        (response) => {
            if (
                typeof response.data === "string" &&
                response.data.indexOf("'") > -1
            ) {
                let data = response.data;
                data = data.replace(/'/g, '"');
                data = JSON.parse(data);
                return data;
            }
            return response.data;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};

const ajax = init();

export { ajax as default };
